export default __webpack_public_path__ + "static/media/logo.0563e7d3.webp";